import validate from "/app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+node@25.9.9_@vue+c_a5d702643265889313571525b0e13fab/node_modules/nuxt/dist/pages/runtime/validate.js";
import i18n_45global from "/app/apps/rdp/middleware/i18n.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+node@25.9.9_@vue+c_a5d702643265889313571525b0e13fab/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  i18n_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}